import {createActionGroup, emptyProps, props} from '@ngrx/store';

export enum projectUiActionTypes {
  TOGGLE_PROJECT_SETUP_BOX = '[Project Ui] Toggle project Setup Box',
}

export type projectUiChildPayloadTypes =
  projectUiActionTypes.TOGGLE_PROJECT_SETUP_BOX;

export const projectUiActions = createActionGroup({
  source: 'Project UI',
  events: {
    'toggle project setup box': emptyProps(),
    /**
     * The one writer of the current project (`loadedProjectId`): the project guard dispatches it once
     * it has granted access to the project in the URL. Project loads and their completions never set it,
     * so a load that finishes late (a superseded navigation, a background refresh) cannot change it.
     */
    'project activated': props<{ projectId: string }>(),
    /** The project guard stopped waiting for the project's load: its loading state becomes Error. */
    'project load timed out': props<{ projectId: string; error: string }>(),
  },
});
